import Config from "../config/config";
import axios from "axios";

const { baseURL } = Config.API;

const getCategories = () => {
  return axios({
    method: 'GET',
    baseURL,
    url: '/categories',
  });
};

const addCategory = (name) => {
  return axios({
    method: 'POST',
    baseURL,
    url: '/categories',
    data: {
      name,
    },
  });
};

const updateCategory = (id, name) => {
  return axios({
    method: 'PATCH',
    baseURL,
    url: `/categories/${id}`,
    data: {
      name,
    },
  });
};

const deleteCategory = (id) => {
  return axios({
    method: 'DELETE',
    baseURL,
    url: `/categories/${id}`,
  });
};

export default {
  getCategories,
  addCategory,
  updateCategory,
  deleteCategory,
};
